import { setCookie, getCookie, isGoogleCrawler, isDirectLink } from "../utils";
if(!window.getURLParameter){
    window.getURLParameter = (key) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key)
    }
}
const MAX_GAMES_ALLOWED_PLAYING = 2;
const GAMES_PLAYED_COOKIE = 'TTGamesPlayed';
const LIMIT_PLAY_DURATION = 1;
const AUTHOR_COOKIE_NAME = "TT_AUTHOR_ID";

const playedGamesCookieValue = getCookie(GAMES_PLAYED_COOKIE);
const authorCookie = getCookie(AUTHOR_COOKIE_NAME);

let gamesPlayed =  playedGamesCookieValue ? parseInt(playedGamesCookieValue) : 0;

if(!window.websaleLink){
    window.websaleLink = `/store/landing_page/?language_id=${window.languageId || '1'}&age_group=${window.ageGroupId || '1'}`;
}

const addToPlayCount = ()=>{
    gamesPlayed++;
    setCookie(GAMES_PLAYED_COOKIE, gamesPlayed, LIMIT_PLAY_DURATION);
}

export const initPlayerEventListener = ()=>{
    // Listen to message from child window
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    eventer(messageEvent,function(e) {
        if (!e.origin.endsWith('tinytap.it') && !e.origin.endsWith('tinytap.com')) return;
        var key = e.message ? "message" : "data";
        var data = e[key];
        if (window.gameEnded && data.hasOwnProperty("score")) {
            window.gameEnded(data.score);
        }
        if (data.hasOwnProperty("ready")) {
            const coverImage = document.getElementById("coverImage");
            if(coverImage){
                coverImage.classList.add('hide');
            }
        }
        if(data.hasOwnProperty("playGame") && !window.IS_SUBSCRIBED){
            addToPlayCount();
        }
        //run function//
    },false);

}

export const setWebPlayerSrc = () => {
    const webplayer = document.getElementById("webplayer");
    if (webplayer){
        const playerSrc = webplayer.getAttribute("data_src");
        const coverImage = document.getElementById("coverImage");
        webplayer.src = playerSrc;
        coverImage.classList.remove('hide');
        coverImage.addEventListener('click', function(){
            coverImage.classList.add('hide');
        });
        
        /*
            webplayer.addEventListener('load', (event) => {
                //console.log("iframe loaded");
            });
        */
        initPlayerEventListener();
    } else {
        console.error("Couldn't find webplayer in page");
    }
}

export const replaceSpinnerWithWebsaleLink = () => {
    const coverImage = document.getElementById("coverImage");
    const spinner = coverImage.querySelector(".flexholder .spinner");
    const playBtn = coverImage.querySelector(".flexholder .playBtn");
    spinner.classList.add('hide');
    playBtn.classList.remove('hide');
    coverImage.addEventListener('click', function(){
        sendWebsaleEvent('player_button_click', { gamesPlayed, albumId: window.albumId });
        window.location = window.websaleLink || "/store/landing_page/";
    });
}

const replaceWebplayerWithWebsale = () => {
    const webplayer = document.getElementById("webplayer");
    webplayer.remove();
    replaceSpinnerWithWebsaleLink();
}

const gameAllowedByAuthor = ()=>{
    const windowAuthor = parseInt(window.authorId);
    
    if(authorCookie && parseInt(authorCookie) === windowAuthor ){
        return true;
    }
    
    const authorIdQuery = window.getURLParameter("authorId");
    if(authorIdQuery && parseInt(authorIdQuery) === windowAuthor){
        setCookie(AUTHOR_COOKIE_NAME, authorIdQuery);
        return true;
    }

    return false;
}


export const initializeWebplayer = () => {
    if(isGoogleCrawler()){
        console.log("User is crawler or bot");
        replaceWebplayerWithWebsale();
    } else {
        setWebPlayerSrc();
    }

    // Web Player Limitations:
        /*
    } else if(window.IS_SUBSCRIBED){
        console.log("User is subscribed");
        setWebPlayerSrc();
    } else if(gameAllowedByAuthor()){
        console.log("gameAllowedByAuthor - Maple Bear game");
        setWebPlayerSrc();
    } else if(isDirectLink){
        console.log("isDirectLink - no refferer found");
        setWebPlayerSrc();
    } else {
        console.log("User is not subscribed");
        if(gamesPlayed >= MAX_GAMES_ALLOWED_PLAYING){
            console.log(`User played too much, ${gamesPlayed} out of ${MAX_GAMES_ALLOWED_PLAYING} `);
            replaceWebplayerWithWebsale();
        } else {
            console.log(`User still have ${MAX_GAMES_ALLOWED_PLAYING - gamesPlayed} games to play`);
            setWebPlayerSrc();
        }
    }
    */
}